import spinner from 'assets/images/svg/Spinner-1s-200px.svg';
import React, { Component, Suspense } from 'react';
import { Route, Router, Redirect } from 'react-router-dom';
import CodeSplitter from 'helpers/CodeSplitter';
import { ToastBar, Toaster } from 'react-hot-toast';
import Routers from './routes';
import * as Layout from '../layouts';
import { history } from '../helpers';

class RoutesClass extends Component {
  componentDidMount() {}

  render() {
    const ssoCode = new URLSearchParams(window.location.search).get('code');
    const isSsoCallbackPath = window.location.pathname === '/auth/sso-success';

    if (ssoCode && !isSsoCallbackPath) {
      history.replace(`/auth/sso-success?code=${ssoCode}`);
    }

    return (
      <Router history={history}>
        <Suspense
          fallback={
            <div className="d-flex justify-content-center align-items-center vh-100">
              <div>
                <img src={spinner} alt="loader" />
              </div>
            </div>
          }
        >
          {Routers.map(
            ({
              component,
              name,
              componentPath = '',
              redirect,
              path,
              exact = false,
              childrens = []
            }) => {
              if (childrens.length > 0) {
                return (
                  <Route
                    path={path}
                    exact={exact}
                    key={path}
                    render={(props) => {
                      if (redirect) {
                        if (props.location.pathname === path) {
                          props.history.push(redirect);
                        }
                      }

                      const LayoutComponent = Layout[component];

                      return (
                        <LayoutComponent {...props}>
                          {childrens.map(
                            ({
                              componentPath: childComponentPath,
                              name: childrenName = '',
                              path: childrenPath,
                              exact: chidrenExact = false
                            }) => {
                              CodeSplitter.addComponent(
                                childComponentPath,
                                childrenName
                              );

                              return (
                                <Route
                                  path={path + childrenPath}
                                  exact={chidrenExact}
                                  key={path + childrenPath}
                                  render={(childrenProps) => {
                                    const PageComponent =
                                      CodeSplitter.getComponent(childrenName);

                                    return <PageComponent {...childrenProps} />;
                                  }}
                                />
                              );
                            }
                          )}
                        </LayoutComponent>
                      );
                    }}
                  />
                );
              }

              CodeSplitter.addComponent(componentPath, name);

              return (
                <Route
                  path={path}
                  exact={exact}
                  key={component || 2322}
                  render={(props) => {
                    if (component) {
                      const PageComponent = CodeSplitter.getComponent(name);
                      return <PageComponent />;
                    }

                    if (redirect) {
                      if (props.location.pathname === path) {
                        return <Redirect to={redirect} />;
                      }
                    }

                    return <div />;
                  }}
                />
              );
            }
          )}
        </Suspense>
        <Toaster
          position="bottom-right"
          gutter={8}
          reverseOrder
          containerClassName="custom-toast"
          containerStyle={{ right: '40px', bottom: '50px' }}
        >
          {(t) => (
            <ToastBar toast={t} style={{ padding: 0, overflow: 'hidden' }}>
              {({ icon, message }) => {
                return (
                  <div
                    className={`custom-toast-${t.type} d-flex align-items-center custom-toast-item`}
                  >
                    {icon}
                    {message}
                  </div>
                );
              }}
            </ToastBar>
          )}
        </Toaster>
      </Router>
    );
  }
}

export default RoutesClass;
